var scope_0 = require('/codebuild/output/src134744821/src/awsmaniac.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0555d4ff38c408729e062894d4acda18.js').default;
var scope_1 = require('/codebuild/output/src134744821/src/awsmaniac.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/91fed51c50115b1f329e3940d25f571d.js').default;
var scope_2 = require('/codebuild/output/src134744821/src/awsmaniac.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d5a94f16f54d3d4998bfe9d693d4008a.js').default;
var scope_3 = require('/codebuild/output/src134744821/src/awsmaniac.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    